
import { Skeleton } from 'antd'
import React from 'react'

export default function SkeletonPage() {
    return (
        <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
        </>
    )
}
